import { Typography } from "@mui/material";

export default function ErrorContent(obj: any) {
  return (
    <Typography variant="h6">
      An Error Occurred: {obj.error.errorCode}
    </Typography>
  );
}
